<template>
  <div class="news">
    <p class="newTitle">联系我们</p>
    <div class="newsType">
      <div class="lTitle">
        <span>CONTACT US</span>
      </div>
    </div>
    <div class="contact">
      <el-row>
        <el-col :span="8" :xs="12">
          <div class="address">
            <p>地址：{{list.address}}</p>
            <p>技术咨询：{{list.telephone}}</p>
            <p>销售热线：{{list.saletel}}</p>
            <p v-html="list.phone" class="hidden-xs-only">
              <!-- 电话:13663807598 杨经理<br /> -->
              <!-- 		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18736025467 刘经理<br />
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18736027900 赵经理<br />
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18736032500 魏经理<br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18736029621 关经理-->
            </p>
            <p>网址:{{list.url}}</p>
            <p>邮箱:{{list.email}}</p>
            <!-- <ul class="type">
							<li><img src="../../assets/images/home/wx.png" alt="wx"></li>
							<li><img src="../../assets/images/home/wb.png" alt="wb"></li>
							<li><img src="../../assets/images/home/qq.png" alt="qq"></li>
            </ul>-->
          </div>
        </el-col>
        <el-col :span="8">
          <el-form ref="form" :model="form" class="hidden-sm-and-down">
            <el-form-item>
              <el-input v-model="form.name" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.email" placeholder="邮箱"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.phone" placeholder="电话"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.content" placeholder="内容"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="more">
                <input type="button" @click="onSubmit" value="提交" class="submit" />
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" :xs="12">
          <div class="ewm">
            <img src="../../assets/images/home/ewm.png" alt />
            <span>微信公众号</span>
          </div>
        </el-col>
      </el-row>
      <div class="link">
        <span>友情链接</span>
        <ul class="linkList">
          <li v-for="(item,index) in linkList" @click="goLink(item.url)">{{item.name}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        content: "",
      },
      list: [],
      linkList: [],
    };
  },
  created() {
    this.getData();
    this.getLink();
  },
  methods: {
    //获取联系我们
    getData() {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/contact_way",
          qs.stringify({}),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data[0];
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getLink() {
      request
        .post(this.settings.apiBaseUrl + "/api/index/link", qs.stringify({}), {
          headers: {},
        })
        .then((res) => {
          if (res.code == 1) {
            this.linkList = res.data;
            console.log(this.linkList);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    goLink(url) {
      window.open(url, "_blank");
    },
    getStyle(index) {
      this.activeIndex = index;
    },
    onSubmit() {
      if (this.form.name == "") {
        this.$message.error("姓名不可为空");
        return;
      }
      if (!/^1[3|4|5|7|8]\d{9}$/.test(this.form.phone)) {
        this.$message.error("手机号码不正确");
        return;
      }
      if (
        !/^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/.test(
          this.form.email
        )
      ) {
        this.$message.error("邮箱格式不正确");
        return;
      }
      if (this.form.content == "") {
        this.$message.error("内容不可为空");
        return;
      }
      request
        .post(
          this.settings.apiBaseUrl + "api/index/add_form",
          qs.stringify({
            name: this.form.name,
            email: this.form.email,
            mobile: this.form.phone,
            content: this.form.content,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("提交成功");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 0px 220px;
  box-sizing: border-box;
}

.news .newTitle {
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  margin-top: 70px;
}

.newsType .lTitle {
  width: 100%;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  margin-top: 20px;
  margin-bottom: 80px;
}

.lTitle span {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  opacity: 0.5;
}

.about {
  margin-top: 80px;
  width: 60%;
}

.about p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3f3f3f;
  line-height: 30px;
}

.contact {
  width: 100%;
  padding-bottom: 30px;
}

/deep/ .el-col-8 {
  position: relative;
}

/deep/ .el-form-item {
  margin-bottom: 10px;
}

.address p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5a5a5a;
  line-height: 20px;
  margin-bottom: 18px;
}
.address p >>> p span {
  font-size: 18px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 400;
  color: #5a5a5a !important;
  line-height: 25px !important;
}
.type {
  margin-top: 60px;
}

.type li {
  float: left;
  width: 24px;
  height: 24px;
  margin-right: 30px;
}

.type li img {
  width: 100%;
  height: 100%;
}

/deep/ .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

.more {
  width: 100%;
  height: auto;
  text-align: left;
  margin-top: 40px;
  margin-bottom: 0px;
}

.more .submit {
  width: 161px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #216bd1;
  border-radius: 5px;

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #216bd1;
  line-height: 19px;
}

.ewm {
  width: 40%;
  height: 40%;
  margin: 0 auto;
  text-align: center;
}

.ewm img {
  width: 129px;
  height: 129px;
}

.ewm span {
  display: block;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
}
.link {
  width: 100%;
  margin-top: 50px;
}
.link span {
  width: 10%;
  float: left;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
}
.link .linkList {
  width: 90%;
  float: left;
}
.link .linkList li {
  float: left;
  padding-right: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
  cursor: pointer;
}
@media screen and (max-width: 750px) {
  .news .newTitle {
    height: 30px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 0.1rem;
    cursor: pointer;
    font-weight: bold;
    text-align: center;
    color: #216bd1;
  }

  .newsType .lTitle {
    width: 100%;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
  }

  .lTitle span {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 18px;
    opacity: 0.5;
  }

  .address p {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5a5a5a;
    line-height: 0.25rem;
    margin-bottom: 18px;
  }

  .type li {
    float: left;
    width: 0.25rem;
    height: 0.25rem;
    margin-right: 0.3rem;
  }

  .type li img {
    width: 100%;
    height: 100%;
  }

  .news {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    padding: 0px 50px;
    box-sizing: border-box;
  }

  .ewm {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .ewm img {
    width: 2rem;
    height: 2rem;
  }

  .ewm span {
    display: block;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/concat.vue